// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var WatermarkRendererViewMode;
(function (WatermarkRendererViewMode) {
    WatermarkRendererViewMode[WatermarkRendererViewMode["NONE"] = 1] = "NONE";
    WatermarkRendererViewMode[WatermarkRendererViewMode["SYMBOL"] = 2] = "SYMBOL";
    WatermarkRendererViewMode[WatermarkRendererViewMode["DESCRIPTION"] = 3] = "DESCRIPTION";
    WatermarkRendererViewMode[WatermarkRendererViewMode["SYMBOLANDDESCRIPTION"] = 4] = "SYMBOLANDDESCRIPTION";
    WatermarkRendererViewMode[WatermarkRendererViewMode["LOGO"] = 5] = "LOGO";
})(WatermarkRendererViewMode || (WatermarkRendererViewMode = {}));
export function getWatermarkRendererViewModeKey(value) {
    switch (value) {
        case WatermarkRendererViewMode.NONE:
            return 'watermarkMode.None';
        case WatermarkRendererViewMode.SYMBOL:
            return 'watermarkMode.Symbol';
        case WatermarkRendererViewMode.DESCRIPTION:
            return 'watermarkMode.Description';
        case WatermarkRendererViewMode.SYMBOLANDDESCRIPTION:
            return 'watermarkMode.SymbolAndDescription';
        case WatermarkRendererViewMode.LOGO:
            return 'watermarkMode.Logo';
        default:
            return '';
    }
}
